const UploadTabOne = ({ selectValue, setTab }) => {
    if (selectValue) {
        return (
            <div
                className="true-comply-upload__report__bodysection"
                data-testid="tab-1"
            >
                <div className="true-comply-upload__report__bodysection-left">
                    <div className="true-comply-upload__report__bodysection-left-title">
                        Confirm Report / Schedule
                    </div>
                    <p>
                        Please select the Report / Schedule you like to upload files for
                    </p>
                </div>
                <div className="true-comply-upload__report__bodysection-right">
                    <div
                        data-testid="btn-tab1"
                        className="true-comply-upload__report__bodysection-right-regulatory-wrapper"
                        onClick={() => setTab('second')}
                        aria-hidden="true"
                    >
                        {selectValue}
                        <span className="appkiticon icon-right-chevron-outline" />
                    </div>
                </div>
            </div>
        );
    }
    return <div data-testid="empty" />;
};

export default UploadTabOne;
